import type { RouteLocationRaw, RouteRecordRaw } from 'vue-router'
import { PageAvailableFor } from '@/types'
import { AppModule } from '@/config/types'
import type { SignupPhoneVerificationResolverParams } from '@/services/resolvers/auth/types'
import AuthResolver from '@/components/domain/auth/AuthResolver.vue'

export const getSignupPhoneVerificationRoutes = (): RouteRecordRaw[] => [
  {
    name: 'auth.signupPhoneVerification',
    path: 'phone-verification',
    component: () => import('@/components/views/auth/signupPhoneVerification/SignupPhoneVerificationLayoutRoot.vue'),
    meta: {
      pageAvailableFor: PageAvailableFor.notAuthenticated,
      modules: [AppModule.SignupPhoneVerification, AppModule.AutoDetectedCountry],
    },
    children: [
      {
        name: 'auth.signupPhoneVerification.form',
        path: '',
        meta: {
          tabTitle: 'pageTabTitle.auth.verifyPhone',
          resolvers: [
            {
              service: 'SignupPhoneVerificationResolver',
              params: { isPhoneRequired: false } satisfies SignupPhoneVerificationResolverParams,
            },
          ],
          resolverComponent: AuthResolver,
        },
        props: (route) => ({
          email: route.query.email,
          phone: route.query.phone,
        }),
        component: () => import('@/components/views/auth/signupPhoneVerification/SignupPhoneVerificationFormRoot.vue'),
      },
      {
        name: 'auth.signupPhoneVerification.code',
        path: 'code',
        meta: {
          tabTitle: 'pageTabTitle.auth.verifyPhone',
          resolvers: [
            {
              service: 'SignupPhoneVerificationResolver',
            },
          ],
          resolverComponent: AuthResolver,
        },
        props: (route) => ({
          email: route.query.email,
          phone: route.query.phone,
        }),
        component: () => import('@/components/views/auth/signupPhoneVerification/SignupPhoneVerificationCodeRoot.vue'),
      },
    ],
  },
]

export const getSignupPhoneVerificationFormRouteLocation = (email: string, phone?: string) => {
  return {
    name: 'auth.signupPhoneVerification.form',
    query: { email, phone },
  } satisfies RouteLocationRaw
}

export const getSignupPhoneVerificationCodeRouteLocation = (email: string, phone: string) => {
  return {
    name: 'auth.signupPhoneVerification.code',
    query: { email, phone },
  } satisfies RouteLocationRaw
}
